<template>
  <b-container>
    <AccordionText
      v-for="accordion in accordions"
      :key="accordion.id"
      :id="accordion.id"
      :title="accordion.title"
      :text="accordion.text"
    ></AccordionText>
  </b-container>
</template>

<script>
import AccordionText from "../../components/AccordionText";

export default {
  data() {
    return {
      accordions: [
        {
          title: "Définition",
          id: "definition",
          text: `
#### Dans le cadre d’atteinte neurologique

Les troubles neurovisuels sont des troubles de la perception visuelle d’origine centrale. C’est-à-dire qu’ils résultent d'une atteinte cérébrale, d’un dysfonctionnement et/ou d’une ou des lésions cérébrales au niveau des voies visuelles postérieures (au-delà du chiasma optique) avec préservation de l'œil et des voies visuelles antérieures. Ils sont à différencier des troubles ophtalmologiques dus à une atteinte du globe oculaire et/ou des nerfs optiques.

Ils peuvent altérer :

-   La reconnaissance : les agnosies, les troubles perceptifs, la cécité corticale, le syndrome de Balint
-   La détection : la perception de l’espace ou négligence, la localisation visuelle
-   Le mouvement : les dyspraxies visuo-spatiales, troubles perceptivo-moteurs, troubles des stratégies du regard, atteinte musculaire ( paralysie oculo-motrice), apraxie du regard

Ces altérations ont des causes très multiples pouvant arriver à n’importe quel âge: pathologie congénitale, neurodégénérative ( Alzheimer, Parkinson, SEP, …), AVC, traumatisme crânien….

#### Dans le cadre de Trouble neurodéveloppemental

Les troubles [neuro-développementaux](https://www.has-sante.fr/jcms/p_3161334/fr/troubles-du-neurodeveloppement-reperage-et-orientation-des-enfants-a-risque) débutent durant la période du développement de l’enfant et regroupent :

·  les handicaps intellectuels (trouble du développement intellectuel) ;
·  les troubles de la communication ;
·  le trouble du spectre de l’autisme ;
·  le trouble spécifique des apprentissages (lecture, expression écrite et déficit du calcul) ;[dyslexie, dysgraphie, dyscalculie]
·  les troubles moteurs (trouble développemental de la coordination, mouvements stéréotypés, tics) ;
·  le déficit de l’attention/hyperactivité ;
·  les autres TND, spécifiés (par exemple TND associé à une exposition prénatale à l’alcool), ou non.

Les différents apprentissages sont intimement lié au développement de la fonction visuelle. Celle-ci a besoin d’être coordonnée aux fonctions motrices et perceptives afin que l’enfant puisse développer son geste, mais aussi comprendre ce qu’il voit, pour interagir avec son environnement. La communication visuelle est donc également tributaire de la qualité de la vision.
[Questionnaire de suivi ou de reprise de traitement orthoptique](/questionnaires/questionnaire_debut_reprise_suivi_orthoptique.doc)`
        },
        {
          title: "Symptômes",
          id: "symptome",
          text: `Les conséquences fonctionnelles sont diverses en fonction de l’atteinte neurovisuelle: fatigabilité, troubles graphiques, troubles attentionnels, difficultés de coordination oeil-main, difficultés d’analyse visuelle, troubles de la communication visuelle…. L’examen de l’acuité visuelle, de la réfraction ( besoin ou pas de lunettes), et des mouvements oculaires reste un préalable indispensable à toutes les prises en charges.
`
        },
        {
          title: "Traitement",
          id: "traitement",
          text: `Les prises en charges dans ce cadre là sont très variées et s’adaptent aux retentissements fonctionnels de chaque patient. Par des séries d’exercices de fixation, saccades, poursuite, attention visuelle, analyse visuelle et bien d’autre, la rééducation orthoptique prend en charge l’atteinte visuelle dans sa globalité.
`
        }
      ]
    };
  },
  components: {
    AccordionText
  }
};
</script>
